<template>
    <div class="mainContainer">
        <div class="photoContainer"><img :src="require(`@/assets/Photo${pageIdStr}.jpg`)" class="profileImg"></div>
        <div class="label"><img :src="require(`@/assets/Main${pageIdStr}.svg`)" class="label"></div>
        <div class="brother profileName">{{ profileList[pageId-1].artistName }}</div>
        <div class="brother profileMainDetail"><span v-html="profileList[pageId-1].mainDetail"></span></div>
        <div class="brother profileContent1"><span v-html="profileList[pageId-1].content1"></span></div>
        <div class="brother profileContent2"><span v-html="profileList[pageId-1].content2"></span></div>
        <div class="iconContainer"><img class="instagramIcon" src="../assets/MainInstaIcon.svg" @click="gotoInstagram"></div>
        <div class="mainNavi">
            <router-link to="/boxes" class="naviItem">Boxes</router-link>
            <router-link to="/" class="naviItem">Home</router-link>
            <router-link to="/contact1" class="naviItem">Contact</router-link>
        </div>
        <div class="backgroundImageContainer"><img class="backgroundImage" :src="require(`@/assets/Back${backgroundNum}.png`)"></div>
    </div>
</template>

<style scoped>
@font-face {
    font-family: 'LeferiBaseType-RegularA';
    src: url('https://fastly.jsdelivr.net/gh/projectnoonnu/noonfonts_2201-2@1.0/LeferiBaseType-RegularA.woff') format('woff');
    font-weight: normal;
    font-style: normal;
}

.backgroundImageContainer {
    width: 100vw;
    height: 50px;
    overflow: visible;
}

.backgroundImage {
    position: absolute;
    width: 100vw;
    bottom: 0px;
    z-index: -1;
}

.mainNavi {
    display: grid;
    width: calc(100vw - 40px);
    margin-left: 20px;
    height: 120px;
    grid-template-columns: repeat(3, 1fr);
    align-items: center;
    justify-items: center;
}

.naviItem {
    font-family: 'LeferiBaseType-RegularA';
    font-size: 11pt;
    text-decoration: underline;
    color: #0D00B4;
}

.mainPageStyle {
    background-color: none;
}
.mainContainer {
    position: absolute;
    left: 0px;
    top: 0px;
    background-color: white;
    min-height: 100vh;
    width: 100vw;
    overflow: scroll;
    z-index:-2;
}

.photoContainer {
    background-color: white;
    width:100vw;
    height: auto;
}

.profileImg {
    position: relative;
    width:100vw;
    height: auto; 
}

.label {
    width: 18px;
    margin-top: 10px;
    margin-left: 18px;
}

.profileName {
    font-weight: 700;
    font-style: normal;
    font-size: 15pt;
    text-align: left;
    padding-left: 60px;
}

.profileMainDetail {
    font-size: 10pt;
    line-height: 15pt;
    margin-top: 8px;
    padding-left: 60px;
    font-weight: 200;
    font-style: italic;
    text-align: left;
    max-width: 70vw;
}

.profileContent1 {
    font-size: 11pt;
    line-height: 16pt;
    font-weight: 300;
    font-style: normal;
    text-align: center;

    margin-top: 30px;
    margin-left: 30px;
    width: calc(100vw - 60px);
}

.profileContent2 {
    font-size: 9pt;
    line-height: 14pt;
    font-weight: 300;
    font-style: italic;
    text-align: center;
    color: #4C4C4C;

    margin-top: 35px;
    margin-left: 38px;
    margin-bottom: 27px;
    width: calc(100vw - 76px);
}

.iconContainer {
    display: flex;
    justify-content: center;
    width: 100vw;
}

.instagramIcon {
    width: 22px;
}
</style>

<script setup>
import profileList from './profileData.js'
import { useRoute } from 'vue-router'
import { ref } from 'vue';
var route = useRoute();
const pageId = ref(Number(route.params.id));
const pageIdStr = ref(String(route.params.id));

function gotoInstagram() {
    window.open('https://instagram.com/'+String(profileList[Number(route.params.id)-1].instagramId))
}

function getRandomBg() {
  const minCeiled = Math.ceil(1);
  const maxFloored = Math.floor(4);
  return Math.floor(Math.random() * (maxFloored - minCeiled) + minCeiled); // 최댓값은 제외, 최솟값은 포함
}

const backgroundNum = getRandomBg();
</script>
